define('views/linkedcards/linkedcard',[
    "backbone",
    "text!views/linkedcards/linkedcard.html",
    "views/_base/baseview",
    "views/linkedcards/editlinkedcard",
    "fancybox"
], function (Backbone, Template, BaseView, EditLCView, Fancybox) {
    "use strict";

    return BaseView.extend({
        template   : _.template(Template),
        scrollToTop: false,
        isRender   : true,
        needsAuth  : true,
        tagName    : "li",
        className  : "linked-card",
        events     : {
            "click .js-editLinkedCard": "editLC"
        },
        
        initialize: function (options) {
            options = options || {};

            this.LCView = options.LCView;
            this.LCEvents = options.LCEvents;
            _.bindAll(this, "updateCard");
            this.LCEvents.bind("updateCard", this.updateCard);

            this.elementName = options.elementName;

            if (this.model.StatusID == enums.linkedCardStatuses.PendingLinked) {
                this.model.attributes.NickName += ' : Pending';
                this.model.NickName += ' : Pending';
            }

            BaseView.prototype.initialize(this);
        },

        render: function () {
            var data = this.model.toJSON();

            if(data.CardTypeID == enums.cardTypes.GPRDebitCard){
                if(!data.NickName){
                    data.NickName = 'PayForward Debit';
                }
                data.cardLogo = '<span class="linked-card-icon-svg">'+enums.svg.payforwardIcon+'</span>'
            } else {
                var src = (data.NetworkSourceID == enums.networkSources.Visa) ? 'visa_sm' : 'mastercard_sm';
                data.cardLogo = '<img src="img/cards/linked/'+src+'.png" class="linked-card-icon">';
            }

            this.$el.html(this.template({ data: data }));
            if (this.model.StatusID == enums.linkedCardStatuses.PendingLinked) {
                this.$(".js-editLinkedCard").attr('disabled', 'disabled');
                this.$(".js-editLinkedCard").addClass('disabled');
            }

            return this;
        },

        editLC: function (e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            var that = this;

            var editView = new EditLCView({
                LCG : this.model.attributes.LinkedCardGUID, 
                NN : this.model.attributes.NickName,
                I: this.model.attributes.Identifier,
                LCE: this.LCEvents,
                LCV: this.LCView
            });

            $.fancybox(editView.el);

            return this;
        },

        updateCard: function (guid, nn) {
            if (this.model.LinkedCardGUID == guid) {
                this.model.attributes.NickName = nn;
                this.render();
            }
        },

        close: function () {}
    });
});

